import.meta.glob([
  '../images/**',
  '../fonts/**',
]);

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

import './gf-budget-slider.js';
import './gf-strategy-form-layout.js';
import './gf-careers-form-layout.js';
import './sticky-header-scroll.js';
import './mobile-menu.js';
import './mega-menu.js';
import './scroll-inview-animations.js';
import './particles-bg.js';
import './site-buttons.js';
import './featured-boxes-icon-glow.js';
import './featured-boxes-carousel.js';
import './content-carousel.js';
import './content-grid.js';
import './team-listing-carousel.js';
import './yoast-faq.js';
import { init_selfTyper } from './self-typer.js';
import { initGalleryLightbox } from '../scripts/gallery-lightbox.js';

document.addEventListener('DOMContentLoaded', initGalleryLightbox);
document.addEventListener('DOMContentLoaded', init_selfTyper);
